import { isSuperAdminSession } from '../redux/helper';

const EDIT_LOCK_WINDOW_MS = 10 * 60 * 1000;
const EDIT_LOCK_STATUSES = ['Published', 'Accepting bids'];
export const EDIT_LOCK_MESSAGE = 'Edits cannot be made in the last 10 minutes of the auction ending.';

export const isAuctionEditLocked = (auctionData) => {
    if (isSuperAdminSession()) return false;
    if (!auctionData || !EDIT_LOCK_STATUSES.includes(auctionData.status)) return false;
    if (!auctionData.first_lot_end_date) return false;
    return (new Date(auctionData.first_lot_end_date).getTime() - new Date().getTime()) < EDIT_LOCK_WINDOW_MS;
}
